import React, { Component } from "react";
import TimeSlots from "../../journal/timeslots/TimeSlots";
import { timeslotsEqual } from "../../../../helpers/utils";

class TimeSlotsWrapper extends Component {
  constructor(props) {
    super(props);

    this.focusListenerUnsub = null;
    this.blurListenerUnsub = null;
    this.isVisible = false;
    this.refreshAfterFocus = true;
    this.unmounted = false;
  }

  componentDidMount = async () => {
    this.unmounted = false;
    if (this.props.controller.hasNavigation()) {
      this.focusListenerUnsub = this.props.navigation.addListener(
        "focus",
        (c) => {
          this.isVisible = true;
          this.refreshAfterFocus = true;
        },
      );
      this.blurListenerUnsub = this.props.navigation.addListener(
        "blur",
        (c) => {
          this.isVisible = false;
        },
      );
    } else {
      this.isVisible = true;
    }
  };

  componentWillUnmount = async () => {
    this.unmounted = true; //hacky workaround for a deeper leak
    if (this.focusListenerUnsub) this.focusListenerUnsub();
    if (this.blurListenerUnsub) this.blurListenerUnsub();
  };

  shouldComponentUpdate(nextProps) {
    let shouldUpdate = false;

    const isSame =
      this.props.timeslotsUpdateCounter > 0 &&
      nextProps.timeslotsUpdateCounter > 0 &&
      this.props.timeslotsUpdateCounter == nextProps.timeslotsUpdateCounter &&
      this.props.selectedDate == nextProps.selectedDate &&
      timeslotsEqual(
        this.props.timeslots,
        nextProps.timeslots,
        nextProps.selectedDate,
      );

    if (this.isVisible || nextProps.source == "track") {
      if (this.refreshAfterFocus) {
        shouldUpdate = true;
        this.refreshAfterFocus = false;
      } else {
        shouldUpdate = !isSame;
      }
    } else {
      if (!isSame) {
        this.refreshAfterFocus = true;
      }
    }

    //console.log("Rendering timeslots update flag " + shouldUpdate);
    return shouldUpdate;
  }

  render() {
    const props = this.props;
    return !this.unmounted ? <TimeSlots {...props} /> : <></>;
  }
}

export default TimeSlotsWrapper;
